import { gql } from '@apollo/client';

export const GET_ACTIVITY_APPLICATION_QUESTIONS_FOR_APPLY = gql`
  query GetActivityApplicationQuestionsForApply($activityId: String!) {
    vm {
      globalActivityApplicationQuestions {
        activityApplicationQuestionId
        label
        type
        required
        order
      }
      activityApplicationQuestions(activityId: $activityId) {
        activityApplicationQuestionId
        label
        type
        required
        order
      }
    }
  }
`;
